export default __webpack_public_path__ + "static/media/8.b147a9e9.jpg";